import { render, staticRenderFns } from "./home.vue?vue&type=template&id=0345bfb1&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style1 from "./home.vue?vue&type=style&index=1&id=0345bfb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0345bfb1",
  null
  
)

export default component.exports